import { render, staticRenderFns } from "./product-sync-status.vue?vue&type=template&id=4afd78cb&scoped=true&"
import script from "./product-sync-status.vue?vue&type=script&lang=js&"
export * from "./product-sync-status.vue?vue&type=script&lang=js&"
import style0 from "./product-sync-status.vue?vue&type=style&index=0&id=4afd78cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd78cb",
  null
  
)

export default component.exports